import React from 'react';
import cn from 'classnames';
import Grid, { Column } from '@tamagoshi/core/Grid';
import { useBreakpoints } from '@tamagoshi/core/MediaQuery';
import { getFooterContext } from '@context';
import {
  B2BConnectDesktop,
  Chat,
  Accordion,
  Network,
  Quality,
  Links,
  Newsletter,
  Service,
} from './modules';

import styles from './styles/index.module.scss';

const Footer = () => {
  const { platform } = getFooterContext();
  const breakpoints = useBreakpoints();

  return (
    <footer className={styles.footer}>
      <Grid className={styles.grid}>
        <Service />
        <Column
          xs={{ span: 12 }}
          sm={{ span: 12 }}
          md={{ span: 3, offset: 1 }}
          lg={{ span: 2, offset: 1 }}
          xl={{ span: 2, offset: 1 }}
          className={cn(styles.accordionSection, styles.column)}
        >
          <Accordion />
          <Links />
        </Column>
        <Column
          xs={{ span: 12 }}
          sm={{ span: 12 }}
          md={{ span: 7, offset: 1 }}
          lg={{ span: 6 }}
          xl={{ span: 4, offset: 1 }}
          className={styles.column}
        >
          <div className={styles.contactSection}>
            <div className={styles.tabletBlock}>
              <B2BConnectDesktop />
            </div>
            <div className={cn(styles.tabletBlock, styles.desktopBlock)}>
              <Newsletter />
              <Chat />
              <Network />
              <div className={styles.tabletBlock}>
                <Quality platform={platform} breakpoints={breakpoints} />
              </div>
            </div>
          </div>
        </Column>
        <Column
          xs={{ span: 12 }}
          sm={{ span: 12 }}
          lg={{ span: 3 }}
          xl={{ span: 3, offset: 1 }}
          className={cn(styles.mobileBlock, styles.desktopBlock, styles.column)}
        >
          <div className={styles.trustSection}>
            <div className={styles.desktopBlock}>
              <B2BConnectDesktop />
            </div>
            <div className={styles.mobileBlock}>
              <Network />
            </div>
            <div className={cn(styles.mobileBlock, styles.desktopBlock)}>
              <Quality platform={platform} breakpoints={breakpoints} />
            </div>
          </div>
        </Column>
      </Grid>
    </footer>
  );
};

Footer.displayName = 'Footer';

export default Footer;
